import ReactGA from 'react-ga4';

// Initialize GA with your measurement ID
const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const initGA = () => {
  if (!MEASUREMENT_ID) {
    console.warn('Google Analytics Measurement ID is not defined');
    return;
  }
  ReactGA.initialize(MEASUREMENT_ID);
};

// Track page views
export const logPageView = () => {
  if (!MEASUREMENT_ID) return;
  ReactGA.send({ hitType: "pageview", page: window.location.pathname });
};

// Track events
export const logEvent = (category, action, label) => {
  if (!MEASUREMENT_ID) return;
  ReactGA.event({
    category: category,
    action: action,
    label: label,
  });
};

// Track user properties
export const setUserProperties = (properties) => {
  if (!MEASUREMENT_ID) return;
  ReactGA.set(properties);
};

// Common events we might want to track
export const Events = {
  // User related
  USER_SIGNED_UP: 'user_signed_up',
  USER_LOGGED_IN: 'user_logged_in',
  USER_LOGGED_OUT: 'user_logged_out',
  
  // Blast related
  BLAST_CREATED: 'blast_created',
  BLAST_SENT: 'blast_sent',
  BLAST_SCHEDULED: 'blast_scheduled',
  
  // Admin related
  BAR_CREATED: 'bar_created',
  BAR_UPDATED: 'bar_updated',
  BAR_DELETED: 'bar_deleted',
}; 